var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "transfer-contacts" }, [
    _c("div", { staticClass: "transfer-content" }, [
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "\n      Bu işlem, seçilen kanaldaki tüm kullanıcıları başka bir kanala taşıyacaktır.\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "channel-selection" },
        [
          _c("label", [_vm._v("Hedef Kanal")]),
          _vm._v(" "),
          _c("ChannelPicker", {
            attrs: {
              "filter-deleted": true,
              "allowed-types": _vm.filterTypes,
              placeholder: "Kanal seçin",
            },
            model: {
              value: _vm.selectedChannelId,
              callback: function ($$v) {
                _vm.selectedChannelId = $$v
              },
              expression: "selectedChannelId",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons-wrapper" },
        [
          _c(
            "SupsisButton",
            {
              attrs: { secondary: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("cancel")
                },
              },
            },
            [_vm._v("\n        İptal\n      ")]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { primary: "", disabled: !_vm.selectedChannelId },
              on: { click: _vm.startTransfer },
            },
            [_vm._v("\n        Transfer Et\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }